module.exports = __webpack_public_path__ + "img/whatsapp.8f270274.svg";